import { render, staticRenderFns } from "./TramiteEnviado.vue?vue&type=template&id=b1c07b20&"
import script from "./TramiteEnviado.vue?vue&type=script&lang=js&"
export * from "./TramiteEnviado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports